import Quill from "quill";

const InlineEmbed = Quill.import("blots/embed");

class SaysimpleCorrespondenceSeparator extends InlineEmbed {
    static create(value) {
        const node = super.create(value);
        node.setAttribute("class", "saysimple-previous-correspondence");

        return node;
    }
}
SaysimpleCorrespondenceSeparator.blotName = "saysimple-previous-correspondence";
SaysimpleCorrespondenceSeparator.tagName = "span";
SaysimpleCorrespondenceSeparator.className = "saysimple-previous-correspondence";

export default SaysimpleCorrespondenceSeparator;
